import { Link } from 'react-router-dom';
import MindsLogLogo from '../assets/MindsLogLogo.png';
import { useState } from 'react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { label: 'AI Tools', path: '/ai-tools' },
    { label: 'AI', path: '/ai' },
    { label: 'Tech', path: '/tech' },
    { label: 'Trading', path: '/trading' },
    { label: 'Stocks', path: '/stocks' },
    { label: 'Religion', path: '/religion' },
    { label: 'Agriculture', path: '/agri' },
    { label: 'Shopping', path: '/shopping' }
  ];

  return (
    <header>
      <div className="header-content">
        {/* Hamburger Menu */}
        <button 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="hamburger-btn"
        >
          ☰
        </button>
        
        {/* Logo and Brand */}
        <div className="logo-container">
          <Link to="/">
            <img 
              src={MindsLogLogo} 
              alt="MindsLog Logo" 
              className="logo-image"
            />
          </Link>
          <Link to="/" className="logo-text"> Blogs</Link>
        </div>
        
        {/* Desktop Navigation */}
        <nav>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="nav-link"
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className="mobile-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;
